import React from 'react';
import loader from '../../assets/loader.svg';
import { Link } from 'react-router-dom';
import moment from 'moment';
import Modal from "../modal/Modal";
import ConfirmPassword from "../ConfirmPassword";

class Details extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            expectedProgress: 40,
            treatmentProgress: 30,
            showModal: false,
            userType: 'patient'
        }
        this.hideModal = this.hideModal.bind(this);
    }
    componentWillMount(){
        this.setState({
            details: this.props.details
        })
    }

    showModal(id) {
      this.setState({
        showModal: true,
        patientId: id
      })
    }

    hideModal() {
      this.setState({showModal: false});
    }

    render(){
        let getInitials = (value) =>{
            let matches = value.match(/\b(\w)/g);
            let nameBadge = matches.join('');
            return nameBadge;
        }

        let bio = this.props.details.bio,
            record = this.props.details.hospital_record,
            caregiver = this.props.details.caregiver,
            progress =  this.props.details.progress;
        let name, alias, sex, age, phoneNo, TSdate, Ttime, sod, height, weight, caregiverName, pBadge, cBadge, maritalStatus, Tphase, Tno, Tprogress, Eprogress;
        if(bio && record && caregiver){
            name = bio.name;
            alias = bio.alias;
            sex = bio.sex;
            phoneNo = bio.phone_no;
            maritalStatus = bio.marital_status;
            TSdate = moment(record.treatment_start_date).format('ddd, D MMMM YYYY');
            Tphase = record.treatment_phase;
            sod = record.site_of_disease;
            height = record.height;
            weight = record.weight;
            Tno =  record.treatment_no;
            caregiverName = caregiver.name;

            let dob = bio.dob;
            let currentYear = moment();
            age = currentYear.diff(dob, 'years');
            let date = moment().format('YYYY-MM-DD')
            Ttime = moment(`${date} ${record.treatment_time}`).format('h:mm A');

            pBadge = getInitials(name);
            cBadge = getInitials(caregiverName);

            Tprogress = progress.actual/progress.overall_expected * 100;
            Eprogress = progress.expected/progress.overall_expected * 100;
        }
        return(
            <div className="patient-details">
                {
                    !bio &&
                    <div className="loader">
                        <img src={loader} alt=""/>
                    </div>
                }
                {
                    bio &&
                    <div className="row">
                        <div className="col-sm-4">
                            <div className="name-section">
                                <div className="name-badge">
                                    {pBadge.toUpperCase()}
                                </div>
                                <div className="name">
                                    <h4>{name}</h4>
                                    <h5>{alias}</h5>
                                    <h6>{Tno}</h6>
                                </div>
                            </div>
                            <div className="progress-section">
                                <div className="progress">
                                    <div className="e-progress" style={{width: `${Eprogress}%`}}></div>
                                    <div className="t-progress" style={{width: `${Tprogress}%`}}></div>
                                </div>
                                <div className="labels">
                                    <h6><i className="fa fa-circle yellow"></i>Treatment progress</h6>
                                    <h6><i className="fa fa-circle green"></i>Expected progress</h6>
                                </div>
                            </div>
                            <div className="caregiver">
                                <h6>Caregiver</h6>
                                <div className="name-avi">
                                    <span><b>{cBadge.toUpperCase()}</b></span>
                                    <p>{caregiverName}</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-8">
                            <div className="col-sm-12 controls">
                              <Link to='/edit-patient' className="edit-user">Edit User</Link>
                              <button className="archive-user" onClick={() => this.showModal(localStorage.getItem("user_id"))}>Archive user</button>
                            </div>

                            <div className="patient-metric">
                                <div>
                                    <h6>Sex</h6>
                                    <p>
                                        {sex === 'Male' && 'M'}
                                        {sex === 'Female' && 'F'}
                                    </p>
                                </div>
                                <div>
                                    <h6>Age</h6>
                                    <p>{age}</p>
                                </div>
                                <div>
                                    <h6>Height</h6>
                                    <p>{height}m</p>
                                </div>
                                <div>
                                    <h6>Weight</h6>
                                    <p>{weight}kg</p>
                                </div>
                            </div>
                            <div className="patient-contact">
                                <table>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <h6>Phone Number</h6>
                                                <p>{phoneNo}</p>
                                            </td>
                                            <td>
                                                <h6>Marital Status</h6>
                                                <p>{maritalStatus}</p>
                                            </td>
                                            <td>
                                                <h6>Treatment Start Date</h6>
                                                <p>{TSdate}</p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <h6>Treatment Time</h6>
                                                <p>{Ttime}</p>
                                            </td>
                                            <td>
                                                <h6>Treatment Phase</h6>
                                                <p>{Tphase}</p>
                                            </td>
                                            <td>
                                                <h6>Site of disease</h6>
                                                <p>{sod}</p>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <Modal show={this.state.showModal} handleClose={this.hideModal}>
                                  {this.state.showModal && (
                                    <ConfirmPassword
                                      action='archive'
                                      userType={this.state.userType}
                                      userID={this.state.patientId}
                                    />
                                  )}
                                </Modal>
                            </div>
                        </div>
                    </div>
                }
            </div>
        )
    }
}

export default Details;



// WEBPACK FOOTER //
// ./src/components/patientProfile/Details.js